import { render, staticRenderFns } from "./s-icons.vue?vue&type=template&id=a145a1b0&scoped=true&"
import script from "./s-icons.vue?vue&type=script&lang=js&"
export * from "./s-icons.vue?vue&type=script&lang=js&"
import style0 from "./s-icons.vue?vue&type=style&index=0&id=a145a1b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a145a1b0",
  null
  
)

export default component.exports